module.exports = __webpack_public_path__ + "static/media/ic-fund-selection.620c3438.svg";